import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import { Card, Result, Spin } from 'antd';

const PaymentCallbackError: React.FC = () => {
  const navigate = useNavigate();
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  useEffect(() => {
    const isAiCreditPayment = localStorage.getItem('sahaPaymentDestination') === 'ai-credit';
    localStorage.removeItem('sahaPaymentDestination');
    localStorage.removeItem('sahaAiCreditPurchaseId');
    setTimeout(() => {
      navigate(isAiCreditPayment ? '/ai-assistant' : '/course');
    }, 5000);
  }, [navigate])

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <Card style={{ maxWidth: 600, width: '100%', textAlign: 'center' }}>
      <Result
        status="error"
        title="Ödeme Başarısız"
        subTitle="Ödemeniz alınamadı. Tekrar denemeniz için yönlendiriliyorsunuz."
      />
      <Spin indicator={antIcon} style={{ marginTop: 16 }} />
    </Card>
  </div>
  );
};

export default PaymentCallbackError;
